import SectionLabel from "./SectionLabel";
import { capabilities } from "@/content/homepage";

export default function Capabilities() {
  return (
    <section
      id="capabilities"
      className="av-section av-capabilities"
      aria-labelledby="av-capabilities-title"
      data-testid="capabilities-section"
    >
      <div className="av-shell av-capabilities-grid">
        <div className="av-sticky-heading">
          <SectionLabel inverse>Capabilities</SectionLabel>
          <h2 id="av-capabilities-title">
            Technology transformation services.
          </h2>
        </div>
        <div className="av-capability-list">
          {capabilities.map((capability) => (
            <article className="av-capability" key={capability.number}>
              <span className="av-index">{capability.number}</span>
              <h3>{capability.title}</h3>
              <p>{capability.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
